import './bootstrap'

// window.$ = window.jQuery = require('jquery')

import { createApp } from 'vue'
import HelloWorld from './components/Welcome'
import CarouselContent from './components/common/CarouselContent.vue'
import CarouselSociedad from './components/common/CarouselSociedad.vue'
import VideoGeneric from './components/common/VideoGeneric.vue'
import Facilities from './components/Facilities.vue'
import FormPqrs from './components/FormPqrs.vue'
import Newsletter from './components/Newsletter.vue'
import NewsEdit from './components/admin/dashboard/NewsEdit.vue'
import Dashboard from './components/admin/dashboard/Dashboard.vue'
import PublicacionesDashboard from './components/admin/dashboard/PublicacionesDashboard.vue'
import SubscriptionRegister from './components/common/SubscriptionRegister.vue'
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'
import { vfmPlugin } from 'vue-final-modal'

const app = createApp({})

app
  .component('hello-world', HelloWorld)
  .component('CarouselContent', CarouselContent)
  .component('CarouselSociedad', CarouselSociedad)
  .component('Facilities', Facilities)
  .component('VideoGeneric', VideoGeneric)
  .component('Newsletter', Newsletter)
  .component('FormPqrs', FormPqrs)
  .component('Dashboard', Dashboard)
  .component('PublicacionesDashboard', PublicacionesDashboard)
  .component('NewsEdit', NewsEdit)
  .component('SubscriptionRegister', SubscriptionRegister)

const esLang = {
  dashboard: {
    btn: {
      play: 'Reproducir',
      pause: 'Pausa',
      fullscreen: 'Pantalla completa',
      exitFullscreen: 'Sair del modo pantalla completa ',
      mute: 'Silenciar',
      unmute: 'Subir Volumen',
      back: 'Atras',
      pip: 'Modo PiP',
    },
    settings: {
      autoplay: 'Auto reproducir',
      loop: 'Repetir',
      speed: 'Velocidad',
      resolution: 'Resolucion',
    },
  },
  layers: {
    error: {
      title: 'Error!',
      2404: 'Video Source Undefined',
      2502: 'Media Network Error',
      2503: 'Video Cannot DECODE',
      2504: 'Video Cannot Play!',
      601: 'Live video Cannot Play!',
    },
    loading: {
      msg: 'Cargando ...',
    },
  },
}

app
  .use(Vue3VideoPlayer, {
    lang: esLang,
  })
  .use(vfmPlugin)

app.mount('#app')
